import { useMemo } from "react";
import { businessLocations } from "../../core/data/scanPlan";
import { planScan } from "../../core/data/planScan";

// Everything the search page works out from the form (core/data/planScan.js,
// shared with the CSV upload).
// districts: postcode_districts; maxPostcodes: the account's postcode limit.
export default function useScanPlan(form, niches, now, districts, maxPostcodes) {
  const { keywords, nicheChoice, samples, spacing, business, sites, radius, shuffle, removedPicks } = form;

  return useMemo(() => planScan({
    keywords, nicheChoice, samples, spacing,
    centres: businessLocations(business, sites),
    radius, shuffle, removedPicks, extras: form.postcodes,
    districts, maxPostcodes, niches, now,
  }), [keywords, form.postcodes, business, sites, radius, shuffle, removedPicks, districts, maxPostcodes, nicheChoice, samples, spacing, niches, now]);
}
